module.exports = __webpack_public_path__ + "static/media/T11 - Spiga.e72f91c5.jpg";